/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import GridTableComponent from './gridComponents/LogBatchTableGrid';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  saveLogBatchFilterData,
  getCheckPayeeList,
  getLogBatchTotalList,
  setLogBatchTotalSelectListDetail,
  handleErrorMessages,
  dispatchLogBatchTotalList,
  dispatchLogBatchFilterData,
  setDetailScreenObj,
} from '../store/actions';
import { checkFutureDate, checkBackwardDate } from './commonFunctions';
import {
  NO_DATA_FOUND_ERROR,
  BATCHES_PAYEE_REQUIRED,
  FROM_DATE_LESS_THAN_TO_DATE_ERROR,
  ERROR_DATE_FORMAT,
  TO_DATE_FUTURE_ERROR,
  FROM_DATE_FUTURE_ERROR,
  TO_DATE_BACKWARD_ERROR,
  FROM_DATE_BACKWARD_ERROR,
  CHECK_PAYEE_CD,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import showPreloader from '../../../../interceptor/store/Actions';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  MinDate,
  MaxDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';

function LogBatchTotalSearch(props) {
  const dispatch = useDispatch();
  const dateFormat = 'MM/DD/YYYY';
  const dateFormat1 = 'YYYY-MM-DD';
  const dateFormat2 = 'MM/DD/YY';
  const callSaveLogBatchFilterData = (value) =>
    dispatch(saveLogBatchFilterData(value));
  const callFetchLogBatchTotalList = (value) =>
    dispatch(getLogBatchTotalList(value));

  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.errorMessagesInRedux
  );
  const filterData = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.filterData
  );

  const getLogBatchList = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.logBatchList
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [fullScreenView, setFullScreenView] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [logBatchList, setLogBatchList] = useState([]);
  const [batchForPayeeList, setBatchForPayeeList] = useState([]);
  const [filterOP, setFilterOP] = useState([
    { name: 'No filter (Show All)', value: 'noFilter' },
    { name: 'Batch Date', value: 'batchDate' },
    { name: 'CCN', value: 'CCN' },
    { name: 'Batch Number', value: 'batchNumber' },
  ]);
  const [filterValue, setFilterValue] = useState({
    isEdit: false,
    isFilter: true,
    batchesForPayee: userDefaults?.checkPayeeCd || null,
    filterBatchesBy: 'noFilter',
    batchFromDate: null,
    batchToDate: null,
    batchCCN: null,
    batchNumber: null,
    batchCompleteStatus: null,
    batchInCompleteStatus: 'I',
  });
  const [checkPayeeList, setCheckPayeeList] = useState([]);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  React.useEffect(() => {
    setLoading(true);
    // if (getLogBatchList && getLogBatchList?.data?.length > 0) {
    //   setTimeout(() => dispatch(showPreloader(false)), 10);
    // }
    getCheckPayeeList({ codeDomainList: ['CHECK_PAYEE_CD'] }).then((resp) => {
      setCheckPayeeList(resp);
    });
  }, []);

  React.useEffect(() => {
    if (generalSystemParameterDetails?.[0]?.checkLogByCcnInd !== 1) {
      let optList = filterOP;
      const filteredOption = optList?.filter((item) => item.value !== 'CCN');
      optList = filteredOption;
      setFilterOP(optList);
    }
  }, [generalSystemParameterDetails]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/logBatchSearch') {
          if (
            errorMessagesFromRedux?.searchLogErrors &&
            errorMessagesFromRedux?.searchLogErrors.length > 0
          ) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [JSON.stringify(errorMessagesFromRedux)]);

  React.useEffect(() => {
    let list = [];

    if (checkPayeeList && !_.isEmpty(checkPayeeList)) {
      if (
        checkPayeeList.CHECK_PAYEE_CD &&
        !_.isEmpty(checkPayeeList.CHECK_PAYEE_CD)
      ) {
        list = _.map(checkPayeeList.CHECK_PAYEE_CD, (val, ind) => ({
          id: val?.codeValueID?.codeValue,
          name: `${val?.codeValueID?.codeValue} - ${val.shortDescription}`,
        }));
      }
    } else {
      setLoading(false);
    }
    setBatchForPayeeList(list);
  }, [checkPayeeList]);

  const fetchLogBatchList = () => {
    const request = {
      batchNumber: filterData.batchNumber,
      batchFromDate: filterData.batchFromDate
      ? moment(filterData.batchFromDate).format("MM/DD/YYYY")
      : null,
      batchToDate: filterData.batchToDate
      ? moment(filterData.batchToDate).format("MM/DD/YYYY")
      : null,
      completeStatus: filterData.batchCompleteStatus
        ? filterData.batchCompleteStatus
        : '',
      inCompleteStatus: filterData.batchInCompleteStatus
        ? filterData.batchInCompleteStatus
        : '',
      cashControlNumber: filterData.batchCCN,
      checkCode: filterData.batchesForPayee,
    };
    callFetchLogBatchTotalList(request);
  };
  const clearNoDataFoundError = (errMsg) =>
    errMsg.filter(
      (err) =>
        !(
          err.field === 'logBatchList' &&
          err.errorType === 'NO_DATA_FOUND_ERROR'
        )
    );
  React.useEffect(() => {
    setFilterValue(filterData);
    if (
      (filterData.batchesForPayee && filterData.isFilter) ||
      (_.isEmpty(getLogBatchList) && !filterData.isFilter)
    ) {
      let localErr = errorMessagesFromRedux?.searchLogErrors
        ? errorMessagesFromRedux?.searchLogErrors
        : [];
      if (!filterData.batchesForPayee || filterData.batchesForPayee === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'checkPayeeCd',
          errorType: 'checkPayeeCdRequired',
          message: BATCHES_PAYEE_REQUIRED,
        });
        dispatch(dispatchLogBatchTotalList([]));
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
        );
        setLoading(true);
        fetchLogBatchList();
      }
      const unique = [...new Set(localErr)];
      setErrorMessages(unique);
      const objError = errorMessagesFromRedux || {};
      objError.searchLogErrors = unique;
      dispatch(handleErrorMessages(objError));
    }
  }, [filterData]);
  React.useEffect(() => {
    if (!filterData.isEdit) {
      const obj = {
        ...filterData,
        batchesForPayee: userDefaults?.checkPayeeCd || '-1',
      };
      dispatch(dispatchLogBatchFilterData(obj));
      setLoading(true);
    }
  }, [userDefaults]);
  React.useEffect(() => {
    let list = [];
    let errorMsg = [];
    if (getLogBatchList && !_.isEmpty(getLogBatchList)) {
      if (
        getLogBatchList.message === 'SUCESS' &&
        getLogBatchList.status === '001'
      ) {
        list = getLogBatchList.data || [];
        if (_.isEmpty(list)) {
          errorMsg = NO_DATA_FOUND_ERROR;
        }
      }

      setLoading(false);
    }

    if (!_.isEmpty(errorMsg)) {
      const checkErrPass = !_.isEmpty(errorMessages)
        ? _.filter(errorMessages, {
            field: 'logBatchList',
            errorType: 'NO_DATA_FOUND_ERROR',
          })
        : [];
      if (_.isEmpty(checkErrPass)) {
        const arr = errorMessages;
        arr.push({
          field: 'logBatchList',
          error: true,
          errorType: 'NO_DATA_FOUND_ERROR',
          message: errorMsg,
        });
        const unique = [...new Set(arr)];
        setErrorMessages(unique);
        const objError = errorMessagesFromRedux || {};
        objError.searchLogErrors = unique;
        dispatch(handleErrorMessages(objError));
      }
    } else {
      const indexOf = !_.isEmpty(errorMessages)
        ? _.findIndex(errorMessages, {
            field: 'logBatchList',
            errorType: 'NO_DATA_FOUND_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMessages.splice(indexOf, 1);
      }
    }

    setLogBatchList(list);
  }, [getLogBatchList]);

  const saveFilterValue = useCallback((data) => {
    callSaveLogBatchFilterData(data);
  }, []);

  const filterAction = useCallback(
    (flType, value) => {
      let isEdit = false;
      let isFilter = false;
      if (
        _.includes(
          [
            'batchCCN',
            'batchNumber',
            'batchCompleteStatus',
            'batchInCompleteStatus',
          ],
          flType
        )
      ) {
        if (_.includes(['batchCCN', 'batchNumber'], flType)) {
          isEdit = !_.isEmpty(value);
        } else {
          isFilter = true;
          isEdit = true;
        }
      }
      if (
        _.includes(['batchCompleteStatus', 'batchInCompleteStatus'], flType)
      ) {
        if (flType == 'batchCompleteStatus') {
          if (!value) {
            if (!filterValue.batchInCompleteStatus) {
            } else {
              saveFilterValue({
                ...filterValue,
                [flType]: value,
                isFilter: isFilter,
                isEdit: isEdit,
              });
            }
          } else {
            saveFilterValue({
              ...filterValue,
              [flType]: value,
              isFilter: isFilter,
              isEdit: isEdit,
            });
          }
        } else if (flType == 'batchInCompleteStatus') {
          if (!value) {
            if (!filterValue.batchCompleteStatus) {
            } else {
              saveFilterValue({
                ...filterValue,
                [flType]: value,
                isFilter: isFilter,
                isEdit: isEdit,
              });
            }
          } else {
            saveFilterValue({
              ...filterValue,
              [flType]: value,
              isFilter: isFilter,
              isEdit: isEdit,
            });
          }
        }
      } else {
        saveFilterValue({
          ...filterValue,
          [flType]: value,
          isFilter: isFilter,
          isEdit: isEdit,
        });
      }
    },
    [filterValue]
  );

  const onCancelFilter = () => {
    callSaveLogBatchFilterData({
      ...filterValue,
      filterBatchesBy: 'noFilter',
      batchFromDate: null,
      batchToDate: null,
      batchCCN: null,
      batchNumber: null,
      isFilter: true,
      isEdit: false,
    });
    setErrorMessages([]);

    const objError = errorMessagesFromRedux || {};
    objError.searchLogErrors = [];
    dispatch(handleErrorMessages(objError));
  };

  const onAddDetailAction = (actionType) => {
    dispatch(setDetailScreenObj({}));
    if (actionType === 'Add') {
      dispatch(
        setLogBatchTotalSelectListDetail({
          actionType: 'Add',
          orgData: {},
          updatedData: {},
        })
      );
    }

    const obj = errorMessagesFromRedux || {};

    obj.searchLogErrors = errorMessagesFromRedux?.searchLogErrors
      ? errorMessagesFromRedux?.searchLogErrors
      : [];
    obj.detailLogErrors = [];
    obj.batchNum = '';
    obj.successMessage = '';

    dispatch(handleErrorMessages(obj));
    if (!_.isEmpty(getLogBatchList)) {
      dispatch(dispatchLogBatchTotalList([]));
    }
    setLoading(false);
    redirectURLLink('/logBatchDetail', 'Batch Total Detail', props.history);
  };

  const onChangeBatchesForPayee = (e) => {
    let localErr = errorMessagesFromRedux?.searchLogErrors
      ? errorMessagesFromRedux?.searchLogErrors
      : [];
    if (!e.target.value || e.target.value === '-1') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'checkPayeeCd',
        errorType: 'checkPayeeCdRequired',
        message: BATCHES_PAYEE_REQUIRED,
      });
      dispatch(dispatchLogBatchTotalList([]));
    } else {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
      );
    }

    const request = {
      ...filterValue,
      batchesForPayee: e.target.value,
      isFilter: false,
      isEdit: true,
    };
    if (e.target.value && !_.isEmpty(e.target.value)) {
      request.isFilter = true;
    }
    saveFilterValue(request);
    const unique = [...new Set(localErr)];
    setErrorMessages(unique);
    const objError = errorMessagesFromRedux || {};
    objError.searchLogErrors = unique;
    dispatch(handleErrorMessages(objError));
  };

  const onFilterBachesByChange = (e) => {
    const request = {
      ...filterValue,
      filterBatchesBy: e,
      isFilter: false,
      isEdit: false,
    };
    if (e && e === 'noFilter') {
      request.isFilter = true;
    }

    saveFilterValue(request);
  };

  const onBatchDateChange = (field, date) => {
    const updatedFilter = {
      ...filterValue,
      [field]: date,
      isEdit: false,
      isFilter: false,
    };
    let errMsg = errorMessagesFromRedux?.searchLogErrors || [];
    errMsg = clearNoDataFoundError(errMsg);
    setErrorMessages(errMsg);
    dispatch(
      handleErrorMessages({
        ...(errorMessagesFromRedux || {}),
        searchLogErrors: errMsg,
      })
    );
    saveFilterValue(updatedFilter);
  };
  

const clearErrorsForField = (errMsg, field) =>
  errMsg.filter(err => err.field !== field);
  const addError = (errMsg, field, errorType, message) => {
  const exists = errMsg.some(err => err.field === field && err.errorType === errorType);
  if (!exists) {
    errMsg.push({ field, error: true, errorType, message });
  }
  return errMsg;
};

const onBatchDateBlur = (field, rawValue) => {
  const inputValue = rawValue?.replace(/_/g, '').trim();

  let errMsg = [
    ...(errorMessagesFromRedux?.searchLogErrors || []),
  ];

  // Clear existing date errors
  errMsg = errMsg.filter(
    (err) => !['batchFromDate', 'batchToDate'].includes(err.field)
  );
  const request = {
    ...filterValue,
    isEdit: false,
    isFilter: false,
  };

  if (!inputValue) {
    request[field] = null;
    saveFilterValue(request);
    setErrorMessages(errMsg);
    dispatch(
      handleErrorMessages({
        ...(errorMessagesFromRedux || {}),
        searchLogErrors: errMsg,
      })
    );

    return;
  }

  const parsedDate = moment(
    inputValue,
    ['MM/DD/YYYY', 'MM/DD/YY'],
    true
  );

  // Invalid Date
  if (!parsedDate.isValid()) {
    errMsg.push({
      field,
      error: true,
      errorType: 'ERROR_DATE_FORMAT',
      message: ERROR_DATE_FORMAT,
    });
    request[field] = null;
    saveFilterValue(request);
    setErrorMessages(errMsg);
    dispatch(
      handleErrorMessages({
        ...(errorMessagesFromRedux || {}),
        searchLogErrors: errMsg,
      })
    );

    return;
  }
  const formattedDate = parsedDate.format('MM/DD/YYYY');

  request[field] = formattedDate;

  const fromDate =
    field === 'batchFromDate'
      ? formattedDate
      : request.batchFromDate;

  const toDate =
    field === 'batchToDate'
      ? formattedDate
      : request.batchToDate;

  // Future Date Validation
  if (parsedDate.isAfter(moment(), 'day')) {
    errMsg.push({
      field,
      error: true,
      errorType: 'DATE_CANNOT_BE_FUTURE',
      message:
        field === 'batchFromDate'
          ? FROM_DATE_FUTURE_ERROR
          : TO_DATE_FUTURE_ERROR,
    });
  }
  if (
    fromDate &&
    toDate &&
    moment(fromDate, 'MM/DD/YYYY').isAfter(
      moment(toDate, 'MM/DD/YYYY'),
      'day'
    )
  ) {
    errMsg.push({
      field: 'batchFromDate',
      error: true,
      errorType: 'FROM_DATE_LESS_THAN_TO_DATE_ERROR',
      message: FROM_DATE_LESS_THAN_TO_DATE_ERROR,
    });
  }
  const hasDateError = errMsg.some((err) =>
    ['batchFromDate', 'batchToDate'].includes(err.field)
  );
  // Enable Search only if both dates exist and no errors
  request.isEdit =
    !!fromDate &&
    !!toDate &&
    !hasDateError;
  saveFilterValue(request);
  setErrorMessages(errMsg);
  dispatch(
    handleErrorMessages({
      ...(errorMessagesFromRedux || {}),
      searchLogErrors: errMsg,
    })
  );
};
const hasFieldError = (field) =>
  errorMessagesFromRedux?.searchLogErrors?.some(
    (err) => err.field === field
  );
 
const getFieldErrorMessage = (field) =>
  errorMessagesFromRedux?.searchLogErrors?.find(
    (err) => err.field === field
  )?.message || '';



const onSearchLogBatch = () => {
  let errMsg = [];

  const { batchFromDate, batchToDate, batchesForPayee } = filterValue;

  if (!batchesForPayee || batchesForPayee === '-1') {
    errMsg.push({
      field: 'checkPayeeCd',
      errorType: 'checkPayeeCdRequired',
      message: BATCHES_PAYEE_REQUIRED,
    });
  }

  if (batchFromDate && batchToDate) {
    if (moment(batchFromDate).isAfter(batchToDate)) {
      errMsg.push({
        field: 'batchFromDate',
        errorType: 'FROM_DATE_LESS_THAN_TO_DATE_ERROR',
        message: FROM_DATE_LESS_THAN_TO_DATE_ERROR,
      });
    }
  }


  setErrorMessages(errMsg);
  dispatch(handleErrorMessages({
    ...errorMessagesFromRedux,
    searchLogErrors: errMsg,
  }));

  const isDateFilterValid =
    (!batchFromDate && !batchToDate) || (batchFromDate && batchToDate);

  if (errMsg.length === 0 && isDateFilterValid) {
    callSaveLogBatchFilterData({
      ...filterValue,
      isFilter: true,
    });
  }
};

  return (
    <div
      className="logBatchTotal tBillPanel padding-0 frr-logBatch"
      data-testid="logBatch-search-component"
    >
      <Spinner load={spinnerLoader} />
      <div className="tabs-container">
        {!fullScreenView && (
          <CustomSeparator parent1="Tasks" parent2="Batch Total" />
        )}
        <DisplayErrorMessages
          errorMessages={
            errorMessagesFromRedux?.searchLogErrors?.length > 0
              ? [
                  ...new Set(
                    _.map(
                      errorMessagesFromRedux.searchLogErrors,
                      (l) => l.message
                    )
                  ),
                ]
              : []
          }
        />

        {!fullScreenView && (
          <div className="no-margin">
            <div className="row mb-2 align-items-center">
              <div
                className={
                  filterValue.filterBatchesBy === 'noFilter'
                    ? 'col-sm-12 col-xl-6 frr-lbt-dropdown-width'
                    : 'col-sm-12 col-xl-5'
                }
              >
                <fieldset
                  className="custom-fieldset batch-for-payee"
                  style={{ height: 'auto' }}
                >
                  <legend className="same-font-family ">
                    Batches for Payee <span className="mandatory"> *</span>{' '}
                  </legend>

                  <div className="form-wrapper">
                    <div className="with-select rmv_border w-50">
                      <TextField
                        id="batches-for-payee-select-box"
                        label="batches-for-payee"
                        select
                        inputProps={{
                          maxlength: 11,
                          id: 'batches-for-payee-select-box',
                        }}
                        InputLabelProps={{ shrink: true }}
                        data-testid="batches-for-payee-select-box"
                        value={filterValue.batchesForPayee}
                        onChange={onChangeBatchesForPayee}
                        className={`frr-display-hidden-label ${
                          errorMessagesFromRedux?.searchLogErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchLogErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd'
                                    ? 'mandate-fields'
                                    : null
                              )
                            : null
                        }`}
                        helperText={
                          errorMessagesFromRedux?.searchLogErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchLogErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd' ? l.message : null
                              )
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.searchLogErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchLogErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd' ? l.message : null
                              )
                            : null
                        }
                        fullWidth
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {!_.isEmpty(batchForPayeeList)
                          ? batchForPayeeList.map((item) => (
                              <MenuItem key={item.id} value={item.id} className="frr-logcheck-dropdown-item">
                                {item.name}
                              </MenuItem>
                            ))
                          : null}
                      </TextField>
                    </div>
                    <div className="mt-3">
                      <Button
                        className="btn btn-success btn-save btn-primary"
                        data-testid="add-new-log-batch"
                        onClick={() => onAddDetailAction('Add')}
                        disabled={!isEnablebyRole}
                      >
                        <SVGComponent iconName="Icon-outline-add-circle" /> New
                        Batch
                      </Button>
                    </div>
                  </div>
                </fieldset>
              </div>

              {filterValue.filterBatchesBy === 'noFilter' && (
                <div className="col-sm-12  col-xl-6 mt-sm-3 mt-md-0 frr-logBatchRadio frr-lbt-custom-padding frr-no-wrap">
                  <RadioGroupComponent
                    data-testid="filter-batches-by-redio-btn"
                    id="filter-batches-by-radio-btn-action"
                    labelName="Filter Batches By"
                    required={false}
                    optionList={filterOP}
                    defaultValue={filterValue.filterBatchesBy}
                    filterAction={(e) => onFilterBachesByChange(e)}
                    className="log-batch-filter-radio"
                  />
                </div>
              )}

              {filterValue.filterBatchesBy !== 'noFilter' && (
                <div className="col-sm-12 col-xl-7 pt-2 frr-lbt-custom-padding">
                  <fieldset
                    className="custom-fieldset "
                    style={{ height: 'auto' }}
                  >
                    <div className="form-wrapper mr-6">
                      {filterValue.filterBatchesBy === 'batchDate' && (
                        <>
                          <div className="mui-custom-form input-md field-md " style={{ width: "200px"}} >
                            <legend className="same-font-family short-legend">
                              From Date
                            </legend>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              data-testid="batches-from-date"
                              id="batch-from-date"
                              placeholder="mm/dd/yyyy"
                              label="From Date"
                              format="MM/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              minDate={MinDate}
                              maxDate={MaxDate}
                              className={
                                errorMessagesFromRedux?.searchLogErrors
                                  ?.length > 0
                                  ? _.map(
                                      errorMessagesFromRedux.searchLogErrors,
                                      (l) =>
                                        l.field == 'batchFromDate'
                                          ? 'mandate-fields'
                                          : null
                                    )
                                  : null
                              }
                              error={hasFieldError('batchFromDate')}
                              helperText={getFieldErrorMessage('batchFromDate')}
                              value={filterValue.batchFromDate}
                              onChange={(date) => onBatchDateChange('batchFromDate', date)}   
                              onBlur={(e) =>
                                onBatchDateBlur(
                                  'batchFromDate',
                                  autoFormateDate(e.target.value)
                                )
                              }
                            />
                             </MuiPickersUtilsProvider>
                          </div>

                          <div className="mui-custom-form input-md field-md">
                            <legend className="same-font-family short-legend">
                              To Date
                            </legend>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              data-testid="batches-to-date"
                              id="batch-to-date"
                              placeholder="mm/dd/yyyy"
                              label="To Date"
                              format="MM/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              className={
                                errorMessagesFromRedux?.searchLogErrors
                                  ?.length > 0
                                  ? _.map(
                                      errorMessagesFromRedux.searchLogErrors,
                                      (l) =>
                                        l.field == 'batchToDate'
                                          ? 'mandate-fields'
                                          : null
                                    )
                                  : null
                              }
                              error={hasFieldError('batchToDate')}
                              helperText={getFieldErrorMessage('batchToDate')}
                              minDate={MinDate}
                              maxDate={MaxDate}
                              value={filterValue.batchToDate}
                              onChange={(date) => onBatchDateChange('batchToDate', date)}   
                              onBlur={(e) =>
                                onBatchDateBlur(
                                  'batchToDate',
                                  autoFormateDate(e.target.value)
                                )
                              }
                            />
                          </MuiPickersUtilsProvider>
                          </div>
                        </>

                      )}

                      {filterValue.filterBatchesBy === 'CCN' && (
                        <div className="mui-custom-form input-md field-md frr-ccn-field">
                          <legend className="same-font-family">CCN</legend>
                          <TextField
                            data-testid="batches-cnn"
                            id="batch-cnn"
                            label="CCN"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxlength: 40 }}
                            value={filterValue.batchCCN}
                            onChange={(e) =>
                              filterAction('batchCCN', e.target.value)
                            }
                          />
                        </div>
                      )}

                      {filterValue.filterBatchesBy === 'batchNumber' && (
                        <div className="mui-custom-form input-md field-md">
                          <legend className="same-font-family">
                            Batch Number
                          </legend>
                          <TextField
                            data-testid="batches-number"
                            id="batch-number"
                            label="Batch Number"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxlength: 50 }}
                            value={filterValue.batchNumber}
                            onChange={(e) =>
                              filterAction('batchNumber', e.target.value)
                            }
                          />
                        </div>
                      )}

                      <div className="mui-custom-form field-md logBatchBtn ">
                        <div className="btn-wrappper">
                          <Button
                            className="btn btn-success btn-save btn-primary"
                            data-testid="log-batch-filter-search"
                            disabled={!filterValue.isEdit}
                            onClick={onSearchLogBatch}
                          >
                            <SVGComponent iconName="Icon-search" /> Search
                          </Button>
                          <Button
                            className="btn btn-cancel btn btn-primary btn btn-primary ml-4"
                            data-testid="log-batch-filter-Cancel"
                            onClick={onCancelFilter}
                          >
                            <SVGComponent iconName="Icon-button-cancel" />{' '}
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="tBillPanel ">
          <GridTableComponent
            logBatchList={logBatchList}
            filterAction={filterAction}
            setLoading={setLoading}
            gridHeight={fullScreenView ? '65vh' : 352}
            setFullScreenView={() => setFullScreenView(!fullScreenView)}
            fullScreenView={fullScreenView}
            errorMessages={errorMessages}
            onAddDetailAction={onAddDetailAction}
            setErrorMessages={setErrorMessages}
            data-testid="log-batch-table-action-call"
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(LogBatchTotalSearch);

